<app-aggregated-amount-item
  name="Google 検索数"
  icon="./assets/google_search.png"
  amount="{{ (googleSearchCount$ | async)?.units }}"
  unit="検索数"
  link=""
  help="{{
    (selectedArtist$ | async)?.nameMain
  }}の UM ホームページが表示される際の Google 検索数です。【{{
    keywords$ | async
  }}】を含む選択期間内の合計検索数です。"
  [rate]="(googleSearchCount$ | async)?.rate"
  [hasAmount]="(googleSearchCount$ | async)?.hasUnits"
  [loading]="loading$ | async"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async"
></app-aggregated-amount-item>
